import React, { useEffect } from "react";
import ColumnsWrapper from "./components/ColumnsWrapper";

const App = () => {
  useEffect(() => {
    // Disable scrolling
    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden"; // For some mobile browsers

    // Prevent touch scrolling on mobile
    const preventScroll = (e) => {
      e.preventDefault();
    };
    
    document.addEventListener("touchmove", preventScroll, { passive: false });

    return () => {
      // Re-enable scrolling when component unmounts
      document.body.style.overflow = "auto";
      document.documentElement.style.overflow = "auto";
      document.removeEventListener("touchmove", preventScroll);
    };
  }, []);

  return <ColumnsWrapper />;
};

export default App;
